import { memo } from 'react';

import styled from 'styled-components';

import { useLocale } from '@locale/translate';
import { theme } from '@styles/theme';

import { ListTextField } from './types';
import { getTranslatedFormText } from './utils';

export const List = memo<{ field: ListTextField }>(({ field }) => {
  const currentLanguage = useLocale();
  return (
    <StyledList>
      {field.text.map((text, i) => {
        return <li key={i}>{getTranslatedFormText(text, currentLanguage)}</li>;
      })}
    </StyledList>
  );
});

const StyledList = styled.ul({
  color: theme.form.value.color,
});
